import React, { PureComponent, useState } from "react";
import { Chart } from "react-google-charts";
import { getCookie } from "../../services/Cookies";
import { ToastError } from "../../services/ToastMsg";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import Box from "@material-ui/core/Box";
import axios from "axios";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CancelIcon from '@mui/icons-material/Cancel';
import MUIDataTable from "mui-datatables";
import { getRequest, putRequest } from "../../services/ApiServices";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { ThemeProvider } from "@mui/styles";
import moment from "moment";
import Moment from "react-moment";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
    tableBody: {
        "& .tss-10rusft-MUIDataTableToolbar-icon": {
            color: "#ff4717",
            boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
            marginLeft: "15px"

        },
        "& .tss-9z1tfs-MUIDataTableToolbar-iconActive": {
            color: "#ff4717",
            boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
            marginLeft: "15px"
        },
        "& .tss-qbo1l6-MUIDataTableToolbar-actions": {
          justifyContent:"left",
           position:"absolute",
          
            },
            "& .tss-1ufdzki-MUIDataTableSearch-main":{
                marginRight:"10px",
                width:500
              },
              "& .tss-1fz5efq-MUIDataTableToolbar-left ":{
               position: "absolute",
               right:25
              }
         },
}))



export default function UsersByChart(props) {
    // const { chartData } = props;
    let { title, chartType, datatype, chartData } = props;
    const [open, setOpen] = React.useState(false);
    const [fullWidth, setFullWidth] = React.useState(true);
    const [UserDetails, setUserDetails] = React.useState();
    const[AnalyticsUser,SetAnalyticsUser] = React.useState([]);
    const dispatch = useDispatch();
    const classes = useStyles();
    let data = chartData;
    if (chartData) {
         ////console.log(chartData);
        const getMuiTheme = () => createTheme({

            overrides: {
                MUIDataTableHeadCell: {
                    root: {
                        textTransform: "none"
                    }
                }
            }
        })

        const handleClose = () => {
            setOpen(false);
        };
        const ChartTypes = () => {
            ////  
            if (data[0].includes("Client")) {
                return "BarChart"
            }
            else if (data[0].includes("OperatingSystem")) {
                return "PieChart"
            }
            else if (data[0].includes("Country")) {
                return "ScatterChart"
            }
            else if (data[0].includes("Device")) {
                return "ColumnChart"
            }
            else if (data[0].includes("Role")) {
                return "ColumnChart"
            }
            else if (data[0].includes("page")) {
                return "ColumnChart"
            }
            else if (data[0].includes("UserType")) {
                return "ScatterChart"
            }
            else if (data[0].includes("Browser")) {
                return "ScatterChart"
            }
            else if (data[0].includes("Date")) {
                return "LineChart"
            }
        }
        let hAxis = {};
        if (data[0].includes("Date")) {
            hAxis = {
                format: "MMM-yyyy"
            };
            //console.log("HAxis",hAxis)
            ;
        }
        else {
            hAxis = {
                scaleType: 'log'
            };
        }


        ////
        let options = {
            title: title,
            colors: data[0].includes("Client") || data[0].includes("Date") ? ['#e0440e','#0041C2'] : ['#e0440e', '#e6693e', '#ec8f6e', '#f3b49f', '#f6c7b6'],
            // colors: { data[0].includes("Client") ? ['#0041C2', '#e0440e'] : },
           
            legend: { position: "bottom" },
            enableInteractivity: true,
            //tooltip: { isHtml: true, trigger: "selection" },
            format: 'none',
            hAxis: { format: '0' },
            vAxis: data[0].includes("Date")? {title:"Number of Users",titleFontSize:14,titleTextStyle: {bold:true,italic:false}}:"",
            //  hAxis: {
            //      gridlines: {
            //        count: 1
            //      }
            //    }, 
            //  vAxis: {
            //    ticks: [ 0,50,100,150,200,250]
            //  } 
            // vAxis: {
            //     minValue: 0,
            //     ticks: [0, .3, .6, .9, 1]
            //   }
        };
        //let data = [];

        ////console.log("data", ...data)

        const columns = [
            {
                name: "username",
                label: "User Name",
                options: {
                    filter: true,
                    sort: true,

                }
            }, {
                name: "userrole",
                label: "User role",
                options: {
                    filter: true,
                    sort: true,

                }
            }, {
                name: "clientname",
                label: "Client Name",
                options: {
                    filter: true,
                    sort: true,

                }
            }, {
                name: "ipaddress",
                label: "IP Address",
                options: {
                    filter: true,
                    sort: true,

                }
            }, {
                name: "device",
                label: "Device ",
                options: {
                    filter: true,
                    sort: true,

                }
            }, {
                name: "activity",
                label: "Activity ",
                options: {
                    filter: true,
                    sort: true,

                }
            }, {
                name: "date",
                label: "Date ",
                options: {
                    filter: true,
                    sort: true,
                    // filterOptions: {

                    //     renderValue: (value) => {
                    //         return <Moment format="DD/MM/YYYY">{value}</Moment>
                    //     }
                    // },
                    // customBodyRender: (value, tableMeta, updateValue) => {
                    //     // //
                    //     // let dateString = moment(value).format('MM-DD-YYYY HH:MM:SS');
                    //     // //console.log(dateString) 
                    //     //  return dateString
                    //     return <Moment format="DD/MM/YYYY">{value}</Moment>
                    // }
                }
            }, {
                name: "country",
                label: "Country ",
                options: {
                    filter: true,
                    sort: true,

                }
            }, {
                name: "region",
                label: "Region ",
                options: {
                    filter: true,
                    sort: true,

                }
            }, {
                name: "city",
                label: "City ",
                options: {
                    filter: true,
                    sort: true,
                }
            }, {
                name: "zip",
                label: "Zip ",
                options: {
                    filter: true,
                    sort: true,
                }
            }, {
                name: "lat",
                label: "Latitude ",
                options: {
                    filter: true,
                    sort: true,
                }
            }, {
                name: "longitude",
                label: "Longitude ",
                options: {
                    filter: true,
                    sort: true,
                }
            }, {
                name: "userAgent",
                label: "User Agent ",
                options: {
                    filter: true,
                    sort: true,
                }
            }, {
                name: "os",
                label: "OS",
                options: {
                    filter: true,
                    sort: true,
                }
            }];

          
            const optionss = {
            customToolbarSelect:()=>{
                <>
                onRowsDelete:True,
                </>
                
              },
              selectToolbarPlacement:"above",
    selectableRows:"multiple",
            responsive: 'standard',
            filterType: 'multiselect',
            rowsPerPageOptions: [10, 15, 50, 100],
            textLabels: 'label',
            downloadOptions:{
                filterOptions:{
                  useDisplayedColumnsOnly:true,
                  useDisplayedRowsOnly:true
                }
               },
               
               onRowSelectionChange:(currentRowsSelected,allRowsSelected,rowsSelected)=>{
                let isExist=[];
                rowsSelected.forEach((d)=>{
                isExist.push(UserDetails[d]);
              })
            
              SetAnalyticsUser(isExist)
            },
            
              onDownload:(buildHead, buildBody,columns, gridData)=>{
                
                var myData= [];
                // var newKeys = Object.keys(loginfailedtable[0]);
                var idx = 0;
                var columnsExport = [];
                var columnsExport1 = [];
                columnsExport.push("");
                columns.forEach((cl) => {
                  //if(cl.label!=="Customer Contract")
                  columnsExport.push(cl.label);
            
                })
                // newKeys.forEach((k) => {
                //   columnsExport.push(k);
                // });
                columnsExport.push("\n");
               let i = 0;
               
                //console.log(item);
                AnalyticsUser.length>0?
                (
             AnalyticsUser.forEach((item) => {
                let visibleRows = gridData.filter((df) => {
                  let dfdt = df.data;
                  if (dfdt[0] == item.username && dfdt[1] == item.userrole)
                    return true;
                  else
                    return false;
            
                });
               if (visibleRows.length > 0) {
                
                let itemData = { ...item };
                let dataItem = []
                if (i == 0)
                  dataItem.push("");
                i++;
                
                itemData.clientname = itemData.clientname?.replace(/,/g, "");
               
                let objsample={
                    username:itemData.username,
                    userrole:itemData.userrole,
                    clientname:itemData.clientname,
                    ipaddress:itemData.ipaddress,
                    device:itemData.device,
                    activity:itemData.activity,
                    Date:itemData.date,
                    country:itemData.country,
                    region:itemData.region,
                    city:itemData.city,
                    zip:itemData.zip,
                    latitude:itemData.lat,
                    longitude:itemData.longitude,
                    userAgent:itemData.userAgent,
                    os:itemData.os,
                    
               }
               
                  let data = [];
                  data.push(...Object.values({ ...objsample}));
                  data.push("\n");
                  dataItem.push(data);
                // });
                myData.push(...dataItem);
                // console.log("myData",myData)
               }
            })
                ):(
                
                    UserDetails.forEach((item) => {
                    debugger
                  let visibleRows = gridData.filter((df) => {
                    let dfdt = df.data;
                    if (dfdt[0] == item.username && dfdt[1] == item.userrole)
                      return true;
                    else
                      return false;
              
                  });
                 if (visibleRows.length > 0) {
                  
                  let itemData = { ...item };
                  let dataItem = []
                  if (i == 0)
                    dataItem.push("");
                  i++; 
                  
                  itemData.clientname = itemData.clientname?.replace(/,/g, "");
                  
              let objsample={
                username:itemData.username,
                userrole:itemData.userrole,
                clientname:itemData.clientname,
                ipaddress:itemData.ipaddress,
                device:itemData.device,
                activity:itemData.activity,
                Date:itemData.date,
                country:itemData.country,
                region:itemData.region,
                city:itemData.city,
                zip:itemData.zip,
                latitude:itemData.lat,
                longitude:itemData.longitude,
                userAgent:itemData.userAgent,
                os:itemData.os,
               
                   }
                 
                    let data = [];
                    data.push(...Object.values({ ...objsample}));
                    data.push("\n");
                    dataItem.push(data);
                  // });
                  myData.push(...dataItem);
                  // console.log("myData",myData)
                 }
                })
                )
            buildHead = () => {
            console.log(columnsExport);
            return columnsExport;
            }
            buildBody = () => {
            // console.log(myData);
            return  myData;
            }
            return buildHead() + buildBody();
        }     
        };


        return (
            <>
                <Dialog
                    fullScreen={true}
                    fullWidth={fullWidth}
                    maxWidth="xl"
                    open={open}
                    onClose={handleClose}
                >
                    <DialogActions>
                        <Button onClick={handleClose}><CancelIcon /></Button>
                    </DialogActions>

                    <DialogContent>
                    <Box className="reportstablehead" component="main" mx={3} mt={3}>
                        <ThemeProvider theme={getMuiTheme()}>
                            <MUIDataTable
                                title={"User List"}
                                data={UserDetails}
                                columns={columns}
                                options={optionss}
                                className={classes.tableBody}
                            />
                        </ThemeProvider>
                        </Box>
                    </DialogContent>
                </Dialog>

                <Chart
                    chartType={ChartTypes()}
                    // options={{
                    //      hAxis: {
                    //        title: '',
                    //        gridlines:{color: '#333', minSpacing: 60}
                    //      },
                    //     legend: 'bottom',
                    //     pointSize: 10,
                    //     vAxis: {
                    //       title: '',
                    //       gridlines:{color: '#fff', minSpacing: 60}
                    //     },
                    //     series: {
                    //       1: { curveType: 'function' },
                    //     },
                    //     interpolateNulls: true,
                    //     tooltip: { isHtml: true, trigger: "visible" }
                    //   }}
                    data={chartData}
                    options={options}
                    width={"100%"}
                    height={"400px"}
                    legendToggle
                    chartEvents={[
                        {
                            eventName: "ready",
                            callback: ({ chartWrapper, google }) => {
                                const chart = chartWrapper.getChart();

                                var handler = function (e) {
                                    ////console.log(e);
                                    //
                                    var parts = e.targetID.split("#");
                                    let users = "";
                                    let datatypes = "";
                                    if (parts.indexOf("label") >= 0) {
                                        let idx = parts[parts.indexOf("label") + 1];
                                        idx = parseInt(idx);
                                        ////console.log(data[idx + 1][0]);
                                        ////console.log(data[idx + 1][1]);
                                        users = chartData[idx + 1][0];
                                        datatypes = datatype;
                                        setOpen(true);
                                    } else if (parts.indexOf("legendentry") >= 0) {
                                        let idx = parts[parts.indexOf("legendentry") + 1];
                                        idx = parseInt(idx)
                                        users = chartData[1 + idx][0];
                                        datatypes = datatype;
                                        setOpen(true);
                                    }
                                    if (datatypes == "userspermonth") {
                                        //
                                        dispatch({ type: LOADING, payload: false });
                                    } else {
                                        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Analytics/Analyticsuserdetails/${datatypes}/${users}`;
                                        getRequest(url)
                                            .then((res) => {
                                                if (res.data) {
                                                    //dispatch({ type: LOADING, payload: false });
                                                    //console.log(res.data);
                                                   
                                    

                                                    res.data.forEach((d) => {
                                                        d.date = moment(d.date).format('DD/MM/YYYY');
                                                      })
                                                    //  console.log(res.data);
                                                    setUserDetails(res.data);
                                                } else {
                                                    dispatch({ type: LOADING, payload: false });
                                                    ToastError(res.data.message);
                                                }
                                            })
                                            .catch((error) => {
                                                dispatch({ type: LOADING, payload: false });
                                            });
                                    }

                                };
                                // google.visualization.events.addListener(
                                //     chart,
                                //     "onmouseover",
                                //     e => {
                                //         const { row, column } = e;
                                //         //console.warn("MOUSE OVER ", { row, column });

                                //     }
                                // );
                                // google.visualization.events.addListener(
                                //     chart,
                                //     "onmouseout",
                                //     e => {
                                //         const { row, column } = e;
                                //         //console.warn("MOUSE OUT ", { row, column });
                                //     }
                                // );


                                
                                google.visualization.events.addListener(
                                    chartWrapper.getChart(),
                                    "click",
                                    handler
                                );

                            }
                        }
                    ]}
                />
            </>
        );
    }
    else {
        return <></>;
    }
}